import { render, staticRenderFns } from "./resett.vue?vue&type=template&id=38026a0d&scoped=true&"
import script from "./resett.vue?vue&type=script&lang=js&"
export * from "./resett.vue?vue&type=script&lang=js&"
import style0 from "./resett.vue?vue&type=style&index=0&id=38026a0d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38026a0d",
  null
  
)

export default component.exports